import { Card, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { HTMLAttributes, ReactElement, useState } from 'react';

export interface INotationSelection extends HTMLAttributes<HTMLDivElement> {
  name: string;
  description: string;
  icon: ReactElement;
}

const useStyles = makeStyles({
  notationSelection: {
    cursor: 'pointer',
    border: '1px solid gray',
    margin: '5px',
    '&:hover, &:focus': {
      border: '1px solid #06c',
      backgroundColor: '#06c',
      color: 'white',
    },
  },
  arrowPane: {
    backgroundColor: 'inherited',
    minHeight: '100%',
    color: 'inherited',
  },
});

const NotationSelection = (props: INotationSelection) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const classes = useStyles();
  const hasAttention = isHovered || isFocused;
  return (
    <Card
      className={classes.notationSelection}
      elevation={hasAttention ? 5 : 0}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      raised={true}
      tabIndex={0}
      {...props}
    >
      <Grid container direction="row">
        <Grid
          item
          container
          xs={11}
          direction="column"
          style={{ padding: '1em', backgroundColor: 'white', color: 'black' }}
        >
          <Grid item style={{ paddingBottom: '1em' }}>
            <Typography variant="h5" style={{ display: 'inline-block' }}>
              {props.icon}
              {props.name}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">{props.description}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={1}
          className={classes.arrowPane}
          alignContent="center"
          justifyContent="center"
          alignItems="center"
        >
          <ArrowForwardIosIcon />
        </Grid>
      </Grid>
    </Card>
  );
};

export default NotationSelection;
